/**
 * Returns codes as an array instead of as a String
 * @param {String} codes
 * @param {Array} Code Array
 */
export function makeCodeArray(codesAsString){
    //string placeholder
    let temp ='';
    let codesAsArray = [];
    //remove spaces
    codesAsString = codesAsString.replace(/\s+/g, ''); //https://stackoverflow.com/questions/5963182/how-to-remove-spaces-from-a-string-using-javascript
    if (!codesAsString) {
        alert ("You didn't enter any codes.");
        return false;
    }
    //check to make sure user input is valid (alpha numeric + comma, or throw error)
    for (let char of codesAsString){
        //check if not number, letter or comma
        if (isNaN(char) && !char.match(/[a-z]/i) && char != ','){ //https://stackoverflow.com/questions/9862761/how-to-check-if-character-is-a-letter-in-javascript
            alert('Found a " '+  char +  '", which is not a letter, number, space or comma.');
            return false;
        }
        //character is chill
        if (char == ','){
            //add non empty codes
            if (temp.length != 0) codesAsArray.push(temp);
            temp = '';
        }
        else{
            temp += char;
        }
    }
    //add last string if final char is not comma
    if (temp.length != 0) codesAsArray.push(temp);
    if (codesAsArray.length){
        return codesAsArray;
    } else {
        alert("You didn't eneter any codes!");
        return false;
    }
}


export const DateTimeValidation = {
    weekdaysDayTime: (date, time) =>{
        console.log(date, time)
    }
}